<div class="height-100 overflow-y-auto">
    <div>
        <div class="col-12">
            <h3 class="header display-inline">My Files<span *ngIf="lockScreenService && lockScreenService.lockScreen"> are loading...</span></h3>
        </div>
        <div class="row search-block">
            <div class="col-6 col-lg-4 padding-top-10">
                <mat-form-field appearance="legacy" class="width-100">
                    <mat-label>Search</mat-label>
                    <input matInput placeholder="Start Typing to search for desired Name or Address"
                           [(ngModel)]="searchText"
                           (keyup)="applyFilterMatterSummary()"
                    >
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>

            <div class="col-6 col-lg-8">
                <div class="float-right margin-top-10">
                    <button matTooltip="Refresh My Files" mat-icon-button (click)="refreshList()">
                        <mat-icon color="accent">refresh</mat-icon>
                    </button>
                    <button mat-raised-button color="accent" tabindex="0" class="" (click)="createReferral()">
                        <span>Create Referral</span>
                    </button>
                </div>
            </div>
        </div>

    </div>

    <div class="height-60 overflow-y-auto" #tableDiv (scroll)="onScrollEvent()">
        <table mat-table dp-table-commands tabindex="-1"
               [dataSource]="dataSourceMatterSummary"
               matSort
               multiTemplateDataRows
               class="mat-elevation-z8"
        >

            <ng-container matColumnDef="expanded">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header></th>
                <td mat-cell
                    *matCellDef="let element"
                    (click)="setExpandedElement(element,$event)">
                    <div *ngIf="element === expandedElement" class="padding-left-5">
                        <img src="assets/img/shutter-minus.png" alt="close"/>
                    </div>
                    <div *ngIf="element !== expandedElement" class="padding-left-5">
                        <img src="assets/img/shutter-plus.png" alt="open"/>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="matterTypeName">
                <th mat-header-cell  *matHeaderCellDef mat-sort-header >Type&nbsp;</th>
                <td mat-cell class="mat-cell-large-text"
                    *matCellDef="let element"
                >
                    {{element.matterTypeName | titlecase}}
                </td>
            </ng-container>

            <ng-container matColumnDef="matterAddressOrDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Address&nbsp;</th>
                <td mat-cell class="mat-cell-large-text"
                    *matCellDef="let element"
                >
                    {{element.matterAddressOrDescription}}
                </td>
            </ng-container>

            <ng-container matColumnDef="lawFirm" class="text-align-center">
                <th mat-sort-header mat-header-cell *matHeaderCellDef class="mat-sort-header-container-centered">Law Firm&nbsp;</th>
                <td mat-cell class="mat-cell-large-text"
                    *matCellDef="let element"
                >
                    {{element.lawFirmShort}}
                </td>
            </ng-container>


            <ng-container matColumnDef="matterCloseDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-right width-20-percent">Closing</th>
                <td mat-cell class="mat-cell-large-text"
                    *matCellDef="let element"
                >
                    {{element.matterCloseDate | date : 'MMMM dd, yyyy'}}
                </td>
            </ng-container>



            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
                    <div class="expandable-element-detail"
                         [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                        <div class="row expanded-element-detail">
                            Date: {{element.matterCloseDate | date : 'MMMM dd, yyyy'}}
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr tabindex="0" mat-row *matRowDef="let element; columns: columnsToDisplay;"
                class="connect-home-list" (keydown.enter)="navigateTo(element)" (click)="navigateTo(element)"
                [class.expandable-expanded-row]="expandedElement === element"
            >
            </tr>
            <tr  tabindex="0" mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-detail-row" (click)="navigateTo(row)" (keydown.enter)="navigateTo(row)"></tr>
        </table>

        <div class="back-to-top-block d-12 d-lg-none ">
            <button id="backToTopBtn" title="Go to top" #backToTopBtn (click)="backToTop()"><i class="fa fa-arrow-up"></i></button>
        </div>
    </div>

</div>
